// extracted by mini-css-extract-plugin
export default {"Outer":"EditableDescription_Outer__xWj8I","lightweight":"EditableDescription_lightweight__-7Tjn","bigButton":"EditableDescription_bigButton__NpJiu"};